import { render, staticRenderFns } from "./PesquisaFiltroCertificacao.vue?vue&type=template&id=b0c3cb3e&lang=pug"
import script from "./PesquisaFiltroCertificacao.vue?vue&type=script&lang=js"
export * from "./PesquisaFiltroCertificacao.vue?vue&type=script&lang=js"
import style0 from "./PesquisaFiltroCertificacao.vue?vue&type=style&index=0&id=b0c3cb3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports